export default __webpack_public_path__ + "static/media/10-2.56509af5.mp3";